export default "__VITE_ASSET__mc9kMqB$__"